import React, { Component } from 'react';

class GuildItem extends Component {
    render() {
        return (
            <div
              onClick={this.props.onClickGuild}
              className="guild-item">
              <div className="guild-name">
                {this.props.guild.name}
              </div>
              <div className="members-count">
                {this.props.guild.members.length} members
              </div>
            </div>
        );
    }
}

export default GuildItem;
